import React from "react";
import { ShieldCheckIcon } from "lucide-react";
export function Guarantee() {
  return <section className="w-full bg-[#0a0a1f] py-16" data-id="element-116" data-mp="1o46l2oyafuxo">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-117" data-mp="1o5q1cfjy25zg">
        <div className="flex flex-col items-center gap-6 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.04] p-8 text-center sm:flex-row sm:text-left" data-id="element-118" data-mp="223ofbjucs0ef">
          <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-full border-2 border-emerald-500/40 bg-emerald-500/10" data-id="element-119" data-mp="19eqwnfm8c1l5">
            <ShieldCheckIcon className="h-12 w-12 text-emerald-400" data-id="element-120" data-mp="14gpcssgzby8m" />
          </div>
          <div data-id="element-121" data-mp="1j4txu33i8luk">
            <h2 className="font-display text-2xl font-extrabold text-white" data-id="element-122" data-mp="1j5c3trfyyefo">
              Garantía Incondicional de 7 Días
            </h2>
            <p className="mt-2 text-slate-300" data-id="element-123" data-mp="1ec0unjnoplkl">
              No arriesgas nada. Lee el material y si no sientes que puedes
              conquistar USA, me envías un email y te devuelvo tus{" "}
              <span className="font-semibold text-white" data-id="element-124" data-mp="lnc1q7ws8mjx">$6.39</span>. Te quedas
              con todo el material igual, por haber confiado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}